const AUTH = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTER: '/registration',
  REFRESH: '/refresh-token',
  CHANGE_PASSWORD: '/change-password',
  RESET_PASSWORD: '/reset-password',
};

const AUTOCOMPLETE = {
  GETSEARCHRESULTS: '/GetSearchResults',
};

const CONTACTS = {
  GET: '/contacts',
  EDIT: '/contacts',
  DELETE: '/contacts',
  ADD: '/contacts',
};

const REQUESTS = {
  GetRequest: '/mediko/request', // {id}
  GetList: '/mediko/request/requests',
  CreateMessage: '/mediko/request/create-message',
  GetMessages: '/mediko/request/messages',
  GetDocument: '/mediko/request/document',
  GetDocuments: '/mediko/request/documents',
  GetMailCampaign: '/mediko/mail-campaign/mail-campaigns',
  CopyRequest: '/mediko/request/copy',
};

const COMPANY = {
  GET: '/mediko/company',
  GETCITYMAP: '/mediko/company/getCityMap',
  UPDATE: '/mediko/company/update-company',
  NEW_WORKER: '/mediko/company/add-company-contacts',
  UPDATE_CONTACT: '/mediko/company/update-company-contacts',
  DELETE_CONTACT: '/mediko/company/delete-company-contacts',
  GET_WORKERS: '/mediko/company/get-workers',
  ADD_OFFICE: '/mediko/company/add-company-offices',
  EDIT_OFFICE: '/mediko/company/update-company-offices',
  DELETE_OFFICE: '/mediko/company/delete-company-offices',
};

const WORKER_LIST = {
  UPLOAD_FILES: '/mediko/request/create-documents',
  UPLOAD_FILE: '/mediko/request/create-document',
};

const SEARCH = {
  Get: '/GetSearchResults',
};

const MEDIKO_REQUEST = {
  GET: '/mediko/request',
  GET_REQUESTS: '/mediko/request/requests',
};

const NOMENCLATURES = {
  DOCUMENTS_PER_REQUEST: '/mediko/nomenclature/documents-per-request',
};

const MAIL_CAMPAIGN = {
  CREATE: '/mediko/mail-campaign',
  UPDATE: '/mediko/mail-campaign/update/',
};

export const API = {
  AUTH,
  AUTOCOMPLETE,
  COMPANY,
  CONTACTS,
  MAIL_CAMPAIGN,
  MEDIKO_REQUEST,
  NOMENCLATURES,
  REQUESTS,
  SEARCH,
  WORKER_LIST,
};

export const DIALOG_EXIT_CODE = {
  RESOLVE: 1,
  REJECT: -1,
};
